"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      text: _propTypes.string,
      value: _propTypes.any,
      imageURL: _propTypes.string
    })).isRequired,
    title: _propTypes.string,
    onListSelection: _propTypes.func,
    initialShownItem: _propTypes.number,
    showMoreText: _propTypes.string,
    showMoreIcon: _propTypes.bool,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    isReversed: _propTypes.bool,
    isFullWidth: _propTypes.bool,
    customProperties: _propTypes.object,
    showLessBtn: _propTypes.bool,
    showLessText: _propTypes.string,
    isIndentItem: _propTypes.bool,
    isTextBold: _propTypes.bool,
    textType: _propTypes.string,
    bottomOverlay: _propTypes.bool,
    onSeeMoreClicked: _propTypes.func,
    onSeeLessClicked: _propTypes.func,
    showMoreTextColor: _propTypes.string,
    isShowMoreTextBold: _propTypes.bool,
    withImage: _propTypes.bool,
    isFlexBoxOrientation: _propTypes.bool,
    isMobile: _propTypes.bool,
    withCode: _propTypes.bool
  },
  DefaultProps: {
    onListSelection: function onListSelection() {},
    showMoreText: 'Show more',
    showMoreIcon: false,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isReversed: false,
    isFullWidth: false,
    showLessBtn: false,
    showLessText: 'Show less',
    isIndentItem: false,
    isTextBold: true,
    textType: 'default',
    bottomOverlay: false,
    showMoreTextColor: null,
    isShowMoreTextBold: false,
    withImage: false,
    isFlexBoxOrientation: false,
    isMobile: false
  }
};
exports.default = _default;